import { render, staticRenderFns } from "./MappedData.vue?vue&type=template&id=4c76b836&scoped=true&"
import script from "./MappedData.vue?vue&type=script&lang=js&"
export * from "./MappedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c76b836",
  null
  
)

/* custom blocks */
import block0 from "./MappedData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports